import { connect } from 'react-redux'
import { getModalLimitIsOpen } from '../../reducers/userAccount/selectors/limitModal'
import toggleLimitModal from '../../actions/userAccount/limit/toggleLimitModal'
import {
  getLimitsSorted,
  getLimitsTimeToReset,
} from '../../reducers/userAccount/selectors/getLimits'
import togglePremiumInfoModal from '../../actions/userAccount/limit/togglePremiumInfoModal'
import PremiumLimitModal from './PremiumLimitModal'

const mapStateToProps = state => ({
  limits: getLimitsSorted(state),
  open: getModalLimitIsOpen(state),
  timeToReset: getLimitsTimeToReset(state),
})

const mapDispatchToProps = dispatch => ({
  close: () => dispatch(toggleLimitModal(false)),
  togglePremiumInfoModal: () => dispatch(togglePremiumInfoModal(true)),
})

const LimitModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PremiumLimitModal)

export { LimitModal }
